module.exports = __webpack_public_path__ + "img/salvador-espinosa.874ef26f.png";